import { createSlice  } from '@reduxjs/toolkit';
import { useDispatch,useSelector } from 'react-redux'
import { Navigate, useLocation, useHistory } from 'react-router-dom';
import { clear } from './cartSlice';




// These variables are used to return user informations
const initialState = {
    isModalDisplayed: false,
    modalTitle:"",
    redirectOnOK:false
};



export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    

    DisplayModal: (state)=>{
      state.isModalDisplayed=true
    },

    closeModal: (state)=>{
     
      state.isModalDisplayed=false
      console.log("this is the url: "+window.location.href)
      console.log("this is the url to comp with: "+process.env.REACT_APP_FRONTEND_URL+"shipping#/order")
      if (window.location.href===process.env.REACT_APP_FRONTEND_URL+"#/order"){
        window.location.replace(process.env.REACT_APP_FRONTEND_URL)
      }
      
      
      
    },

    setModalTitle: (state,action)=>{
      state.modalTitle=action.payload
    },

    

  },
});

export const {DisplayModal, closeModal, setModalTitle} = modalSlice.actions;

export const selectisModalDisplayed = (state) => state.modal.isModalDisplayed;

export const selectModalTitle = (state) => state.modal.modalTitle;

export const selectModalRedirect = (state) => state.modal.redirectOnOK;

export default modalSlice.reducer;
